import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPolicy from "../pages/privacy/page";
import TermsOfService from "../pages/terms/page";
import BlogPage from "../pages/blog/page";
import BlogPostPage from "../pages/blog/post";
import BugFixingPage from "../pages/services/bug-fixing";
import CustomDevelopmentPage from "../pages/services/custom-development";
import CloudServicesPage from "../pages/services/cloud-services";
import WorkplaceAutomationPage from "../pages/services/workplace-automation";
import PerformanceOptimizationPage from "../pages/services/performance-optimization";
import SecurityAuditsPage from "../pages/services/security-audits";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogPostPage />,
  },
  {
    path: "/bug-fixing",
    element: <BugFixingPage />,
  },
  {
    path: "/custom-development",
    element: <CustomDevelopmentPage />,
  },
  {
    path: "/cloud-services",
    element: <CloudServicesPage />,
  },
  {
    path: "/workplace-automation",
    element: <WorkplaceAutomationPage />,
  },
  {
    path: "/performance-optimization",
    element: <PerformanceOptimizationPage />,
  },
  {
    path: "/security-audits",
    element: <SecurityAuditsPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfService />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;